import { useState } from "react";

export interface UsePostsModalsReturn {
  // Modais básicos
  rejectModalOpen: boolean;
  setRejectModalOpen: (open: boolean) => void;
  rejectPostId: number | null;
  setRejectPostId: (id: number | null) => void;
  rejectReason: string;
  setRejectReason: (reason: string) => void;

  editingPost: number | null;
  setEditingPost: (id: number | null) => void;
  editContent: string;
  setEditContent: (content: string) => void;
  editHashtags: string;
  setEditHashtags: (hashtags: string) => void;
  editCallToAction: string;
  setEditCallToAction: (cta: string) => void;
  editCallToActionUrl: string;
  setEditCallToActionUrl: (url: string) => void;
  editGalleryItems: Array<{
    file: File | null;
    preview: string;
    type: "image" | "video";
    id?: string;
  }>;
  setEditGalleryItems: (
    items: Array<{
      file: File | null;
      preview: string;
      type: "image" | "video";
      id?: string;
    }>,
  ) => void;

  showDeleteModal: number | null;
  setShowDeleteModal: (id: number | null) => void;
  showPreviewModal: number | null;
  setShowPreviewModal: (id: number | null) => void;
  showScheduleModal: number | null;
  setShowScheduleModal: (id: number | null) => void;
  scheduleDate: string;
  setScheduleDate: (date: string) => void;
  scheduleTime: string;
  setScheduleTime: (time: string) => void;
  schedulingPost: number | null;
  setSchedulingPost: (id: number | null) => void;

  // Modais de publicação
  showMultiPlatformModal: number | null;
  setShowMultiPlatformModal: (id: number | null) => void;
  selectedPostForMultiPublish: any;
  setSelectedPostForMultiPublish: (post: any) => void;
  showUnifiedRepublishModal: boolean;
  setShowUnifiedRepublishModal: (open: boolean) => void;
  selectedPostForRepublish: any;
  setSelectedPostForRepublish: (post: any) => void;
  republishingPost: number | null;
  setRepublishingPost: (id: number | null) => void;

  // Modal de criação
  showCreatePostModal: boolean;
  setShowCreatePostModal: (open: boolean) => void;
  creatingPost: boolean;
  setCreatingPost: (creating: boolean) => void;

  // Modais de mídia
  showImageModal: number | null;
  setShowImageModal: (id: number | null) => void;
  imageModalPostHasContent: boolean;
  setImageModalPostHasContent: (v: boolean) => void;
  imageModalMode: "upload" | "generate";
  setImageModalMode: (mode: "upload" | "generate") => void;
  showEnhanceImageModal: number | null;
  setShowEnhanceImageModal: (id: number | null) => void;
  enhanceImageImageUrl: string;
  setEnhanceImageImageUrl: (url: string) => void;
  showVideoModal: number | null;
  setShowVideoModal: (id: number | null) => void;
  showVideoGenerateModal: number | null;
  setShowVideoGenerateModal: (id: number | null) => void;
  showVideoEditorModal: number | null;
  setShowVideoEditorModal: (id: number | null) => void;
  showSocialVariationsModal: boolean;
  setShowSocialVariationsModal: (open: boolean) => void;
  selectedVariations: Record<string, { public_url: string }> | null;
  setSelectedVariations: (
    variations: Record<string, { public_url: string }> | null,
  ) => void;
  selectedOriginalUrl: string;
  setSelectedOriginalUrl: (url: string) => void;
  selectedPostForVariations: any | null;
  setSelectedPostForVariations: (post: any | null) => void;

  // Estados de loading
  enhancingPost: number | null;
  setEnhancingPost: (id: number | null) => void;
  generatingImage: number | null;
  setGeneratingImage: (id: number | null) => void;
  uploadingImage: number | null;
  setUploadingImage: (id: number | null) => void;
  uploadingVideo: number | null;
  setUploadingVideo: (id: number | null) => void;
  generatingVideo: number | null;
  setGeneratingVideo: (id: number | null) => void;
  publishingPost: number | null;
  setPublishingPost: (id: number | null) => void;

  // Filtros sidebar
  isFilterSidebarOpen: boolean;
  setIsFilterSidebarOpen: (open: boolean) => void;

  // Modal de impulsionamento (Boost)
  showBoostMetaModal: number | null;
  setShowBoostMetaModal: (id: number | null) => void;
  showBoostLinkedInModal: number | null;
  setShowBoostLinkedInModal: (id: number | null) => void;
  selectedPostForBoost: any;
  setSelectedPostForBoost: (post: any) => void;
  boostingPost: number | null;
  setBoostingPost: (id: number | null) => void;

  // Modal de criativo de campanha
  showCreativeEditorModal: number | null;
  setShowCreativeEditorModal: (id: number | null) => void;
  creativeEditorPost: any;
  setCreativeEditorPost: (post: any) => void;
}

export function usePostsModals(): UsePostsModalsReturn {
  // Modais básicos
  const [rejectModalOpen, setRejectModalOpen] = useState(false);
  const [rejectPostId, setRejectPostId] = useState<number | null>(null);
  const [rejectReason, setRejectReason] = useState("");

  const [editingPost, setEditingPost] = useState<number | null>(null);
  const [editContent, setEditContent] = useState("");
  const [editHashtags, setEditHashtags] = useState("");
  const [editCallToAction, setEditCallToAction] = useState("");
  const [editCallToActionUrl, setEditCallToActionUrl] = useState("");
  const [editGalleryItems, setEditGalleryItems] = useState<
    Array<{
      file: File | null;
      preview: string;
      type: "image" | "video";
      id?: string;
    }>
  >([]);

  const [showDeleteModal, setShowDeleteModal] = useState<number | null>(null);
  const [showPreviewModal, setShowPreviewModal] = useState<number | null>(null);
  const [showScheduleModal, setShowScheduleModal] = useState<number | null>(
    null,
  );
  const [scheduleDate, setScheduleDate] = useState("");
  const [scheduleTime, setScheduleTime] = useState("09:00");
  const [schedulingPost, setSchedulingPost] = useState<number | null>(null);

  // Modais de publicação
  const [showMultiPlatformModal, setShowMultiPlatformModal] = useState<
    number | null
  >(null);
  const [selectedPostForMultiPublish, setSelectedPostForMultiPublish] =
    useState<any>(null);
  const [showUnifiedRepublishModal, setShowUnifiedRepublishModal] =
    useState(false);
  const [selectedPostForRepublish, setSelectedPostForRepublish] =
    useState<any>(null);
  const [republishingPost, setRepublishingPost] = useState<number | null>(null);

  // Modal de criação
  const [showCreatePostModal, setShowCreatePostModal] = useState(false);
  const [creatingPost, setCreatingPost] = useState(false);

  // Modais de mídia
  const [showImageModal, setShowImageModal] = useState<number | null>(null);
  const [imageModalPostHasContent, setImageModalPostHasContent] =
    useState(false);
  const [imageModalMode, setImageModalMode] = useState<"upload" | "generate">(
    "upload",
  );
  const [showEnhanceImageModal, setShowEnhanceImageModal] = useState<
    number | null
  >(null);
  const [enhanceImageImageUrl, setEnhanceImageImageUrl] = useState("");
  const [showVideoModal, setShowVideoModal] = useState<number | null>(null);
  const [showVideoGenerateModal, setShowVideoGenerateModal] = useState<
    number | null
  >(null);
  const [showVideoEditorModal, setShowVideoEditorModal] = useState<
    number | null
  >(null);
  const [showSocialVariationsModal, setShowSocialVariationsModal] =
    useState(false);
  const [selectedVariations, setSelectedVariations] = useState<Record<
    string,
    { public_url: string }
  > | null>(null);
  const [selectedOriginalUrl, setSelectedOriginalUrl] = useState("");
  const [selectedPostForVariations, setSelectedPostForVariations] = useState<
    any | null
  >(null);

  // Estados de loading
  const [enhancingPost, setEnhancingPost] = useState<number | null>(null);
  const [generatingImage, setGeneratingImage] = useState<number | null>(null);
  const [uploadingImage, setUploadingImage] = useState<number | null>(null);
  const [uploadingVideo, setUploadingVideo] = useState<number | null>(null);
  const [generatingVideo, setGeneratingVideo] = useState<number | null>(null);
  const [publishingPost, setPublishingPost] = useState<number | null>(null);

  // Filtros sidebar
  const [isFilterSidebarOpen, setIsFilterSidebarOpen] = useState(false);

  // Modal de impulsionamento (Boost)
  const [showBoostMetaModal, setShowBoostMetaModal] = useState<number | null>(
    null,
  );
  const [showBoostLinkedInModal, setShowBoostLinkedInModal] = useState<
    number | null
  >(null);
  const [selectedPostForBoost, setSelectedPostForBoost] = useState<any>(null);
  const [boostingPost, setBoostingPost] = useState<number | null>(null);

  // Modal de criativo de campanha
  const [showCreativeEditorModal, setShowCreativeEditorModal] = useState<
    number | null
  >(null);
  const [creativeEditorPost, setCreativeEditorPost] = useState<any>(null);

  return {
    rejectModalOpen,
    setRejectModalOpen,
    rejectPostId,
    setRejectPostId,
    rejectReason,
    setRejectReason,
    editingPost,
    setEditingPost,
    editContent,
    setEditContent,
    editHashtags,
    setEditHashtags,
    editCallToAction,
    setEditCallToAction,
    editCallToActionUrl,
    setEditCallToActionUrl,
    editGalleryItems,
    setEditGalleryItems,
    showDeleteModal,
    setShowDeleteModal,
    showPreviewModal,
    setShowPreviewModal,
    showScheduleModal,
    setShowScheduleModal,
    scheduleDate,
    setScheduleDate,
    scheduleTime,
    setScheduleTime,
    schedulingPost,
    setSchedulingPost,
    showMultiPlatformModal,
    setShowMultiPlatformModal,
    selectedPostForMultiPublish,
    setSelectedPostForMultiPublish,
    showUnifiedRepublishModal,
    setShowUnifiedRepublishModal,
    selectedPostForRepublish,
    setSelectedPostForRepublish,
    republishingPost,
    setRepublishingPost,
    showCreatePostModal,
    setShowCreatePostModal,
    creatingPost,
    setCreatingPost,
    showImageModal,
    setShowImageModal,
    imageModalPostHasContent,
    setImageModalPostHasContent,
    imageModalMode,
    setImageModalMode,
    showEnhanceImageModal,
    setShowEnhanceImageModal,
    enhanceImageImageUrl,
    setEnhanceImageImageUrl,
    showVideoModal,
    setShowVideoModal,
    showVideoGenerateModal,
    setShowVideoGenerateModal,
    showVideoEditorModal,
    setShowVideoEditorModal,
    enhancingPost,
    setEnhancingPost,
    generatingImage,
    setGeneratingImage,
    uploadingImage,
    setUploadingImage,
    uploadingVideo,
    setUploadingVideo,
    generatingVideo,
    setGeneratingVideo,
    publishingPost,
    setPublishingPost,
    isFilterSidebarOpen,
    setIsFilterSidebarOpen,
    showSocialVariationsModal,
    setShowSocialVariationsModal,
    selectedVariations,
    setSelectedVariations,
    selectedOriginalUrl,
    setSelectedOriginalUrl,
    selectedPostForVariations,
    setSelectedPostForVariations,
    showBoostMetaModal,
    setShowBoostMetaModal,
    showBoostLinkedInModal,
    setShowBoostLinkedInModal,
    selectedPostForBoost,
    setSelectedPostForBoost,
    boostingPost,
    setBoostingPost,
    showCreativeEditorModal,
    setShowCreativeEditorModal,
    creativeEditorPost,
    setCreativeEditorPost,
  };
}
